var _desc, _defs, _rect, _rect2, _g, _line, _circle, _circle2, _rect3, _rect4, _circle3, _circle4, _circle5, _circle6, _image, _image2, _g2, _path, _circle7, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusTpcRelationshipDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 680 680",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "AndUs and Performance Centre relationship") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "AndUs is the technology provider within the Performance Centre Group.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bridge",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF2775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB51B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "blueGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "goldGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFB51B",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB51B",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 678,
    height: 678,
    rx: 28,
    fill: "#FFFFFF",
    stroke: "#D9E4F3",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 630,
    height: 630,
    rx: 21,
    fill: "none",
    stroke: "#E9EFF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 68,
    fill: "#07172F",
    fontSize: 15,
    fontWeight: 760,
    letterSpacing: 4
  }, "ONE PERFORMANCE ECOSYSTEM"), /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 68,
    fill: "#7C8BA1",
    fontSize: 12,
    fontWeight: 700,
    textAnchor: "end"
  }, "TPC GROUP"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 88,
    x2: 606,
    y2: 88,
    stroke: "#E0E8F3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 268,
    r: 190,
    fill: "url(#blueGlow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 268,
    r: 190,
    fill: "url(#goldGlow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 119,
    width: 265,
    height: 315,
    rx: 21,
    fill: "#FFFFFF",
    stroke: "#CFE0F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 119,
    width: 282,
    height: 315,
    rx: 21,
    fill: "#FFF9EE",
    stroke: "#F1DFC0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 266,
    r: 113,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.18
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 266,
    r: 89,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.12,
    strokeDasharray: "3 7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 266,
    r: 113,
    fill: "none",
    stroke: "#FFB51B",
    strokeOpacity: 0.22
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 266,
    r: 89,
    fill: "none",
    stroke: "#FF8A36",
    strokeOpacity: 0.14,
    strokeDasharray: "3 7"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 90,
    y: 183,
    width: 182,
    height: 97,
    preserveAspectRatio: "xMidYMid meet",
    xlinkHref: "andus-logo.png",
    href: "andus-logo.png"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 364,
    y: 175,
    width: 245,
    height: 103,
    preserveAspectRatio: "xMidYMid meet",
    xlinkHref: "tpc-performance-centre-logo.png",
    href: "tpc-performance-centre-logo.png"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 181,
    y: 330,
    fill: "#07172F",
    fontSize: 17,
    fontWeight: 760
  }, "ANDUS"), /*#__PURE__*/React.createElement("text", {
    x: 181,
    y: 357,
    fill: "#52637B",
    fontSize: 13.5
  }, "Applied Intelligence Systems"), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 381,
    width: 172,
    height: 30,
    rx: 15,
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 181,
    y: 401,
    fill: "#087CFF",
    fontSize: 11.5,
    fontWeight: 760,
    letterSpacing: 0.8
  }, "TECHNOLOGY PROVIDER"), /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 330,
    fill: "#07172F",
    fontSize: 17,
    fontWeight: 760
  }, "THE PERFORMANCE CENTRE"), /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 357,
    fill: "#52637B",
    fontSize: 13.5
  }, "Performance Centre Group"), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 381,
    width: 142,
    height: 30,
    rx: 15,
    fill: "#FFF0D4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 401,
    fill: "#C87500",
    fontSize: 11.5,
    fontWeight: 760,
    letterSpacing: 0.8
  }, "GROUP PLATFORM"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315 266h30",
    stroke: "url(#bridge)",
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 266,
    r: 30,
    fill: "#FFFFFF",
    stroke: "url(#bridge)",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif",
    textAnchor: "middle",
    fill: "#07172F",
    fontSize: 8.5,
    fontWeight: 760,
    letterSpacing: 0.7
  }, /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 262
  }, "PART"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 274
  }, "OF"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 466,
    width: 578,
    height: 145,
    rx: 18,
    fill: "#F7FAFE",
    stroke: "#E2EAF5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 511,
    r: 24,
    fill: "#FFFFFF",
    stroke: "#D7E6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 511h22M94 500v22",
    stroke: "url(#bridge)",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 506,
    fill: "#087CFF",
    fontSize: 12.5,
    fontWeight: 760,
    letterSpacing: 2.3
  }, "SHARED PURPOSE"), /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 538,
    fill: "#07172F",
    fontSize: 18,
    fontWeight: 700
  }, "Technology that advances real performance."), /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 566,
    fill: "#52637B",
    fontSize: 14.5
  }, "One group. Practical capability. Intelligent systems."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusTpcRelationshipDesktop);
export default __webpack_public_path__ + "static/media/andus-tpc-relationship-desktop.f1cd469bfb2079898b5464b2db68da37.svg";
export { ForwardRef as ReactComponent };